import { DateUtils } from '@shared/date-utils';

/**
 * Formata ano/mês/dia (mês 0-indexed, como em Date/mesAtual) para o padrão
 * ISO (YYYY-MM-DD) usado nas chaves de `diasLetivosDoMes`.
 */
export function formatarDataISO(ano: number, mes: number, dia: number): string {
  const mesFormatado = (mes + 1).toString().padStart(2, '0'); // Converter 0-11 para 1-12
  const diaFormatado = dia.toString().padStart(2, '0');
  return `${ano}-${mesFormatado}-${diaFormatado}`;
}

/**
 * Verifica se o aluno estava enturmado numa determinada data, considerando
 * o intervalo [dataInicio, dataFim] da enturmação (dataFim opcional = sem fim).
 */
export function verificaAlunoEnturmado(dataSelecionada: string, dataInicio?: string, dataFim?: string): boolean {
  if (!dataInicio) return false;

  const data = new Date(dataSelecionada);
  const inicio = new Date(dataInicio);

  if (dataFim) {
    const fim = new Date(dataFim);
    return data >= inicio && data <= fim;
  }

  return data >= inicio;
}

/**
 * Indica se uma data (só dia/mês/ano local) está dentro do intervalo [início, fim] do período.
 */
export function dataEstaNoPeriodoAvaliativo(
  data: Date,
  periodo: { dataInicial: string; dataFinal: string }
): boolean {
  const pi = DateUtils.parseDateISO(periodo.dataInicial);
  const pf = DateUtils.parseDateISO(periodo.dataFinal);
  if (!pi || !pf) {
    return false;
  }
  const t = new Date(data.getFullYear(), data.getMonth(), data.getDate()).getTime();
  const inicio = new Date(pi.ano, pi.mes, pi.dia).getTime();
  const fim = new Date(pf.ano, pf.mes, pf.dia).getTime();
  return t >= inicio && t <= fim;
}
